import React from "react";

export default function PrivacyPolicy() {
    return (
        <div style={{ padding: "2rem", maxWidth: 800, margin: "0 auto" }}>
            <h1>Privacy Policy</h1>
            <p>Last updated: {new Date().getFullYear()}</p>

            <p>
                MuultiSpace (“we”, “our”, “the platform”) provides tools for creators to
                publish media, build custom pages, and optionally gate content using
                blockchain-based authentication. This Privacy Policy explains what data
                we collect, how we use it, and how you can control it.
            </p>

            <h2>1. Information We Collect</h2>
            <p>We collect the following types of information:</p>
            <ul>
                <li>
                    <strong>Wallet address:</strong> When you connect a Solana wallet, we
                    store your public key for authentication and ownership verification.
                </li>
                <li>
                    <strong>User-provided content:</strong> Media, text, and configuration
                    settings you upload to create your MuultiSpace page.
                </li>
                <li>
                    <strong>Usage data:</strong> Basic analytics such as page views,
                    device type, and general performance metrics.
                </li>
            </ul>

            <h2>2. How We Use Your Information</h2>
            <p>We use collected data only to power the platform:</p>
            <ul>
                <li>Authenticate ownership of your page.</li>
                <li>Render and manage your uploaded content.</li>
                <li>Provide gating features based on NFT ownership or donations.</li>
                <li>Maintain platform performance and security.</li>
            </ul>

            <h2>3. What We Do <em>Not</em> Collect</h2>
            <ul>
                <li>We do not collect private keys.</li>
                <li>We do not store sensitive personal information.</li>
                <li>We do not sell your data to third parties.</li>
            </ul>

            <h2>4. Third-Party Services</h2>
            <p>MuultiSpace uses third-party infrastructure including:</p>
            <ul>
                <li>Firebase (authentication, Firestore, storage)</li>
                <li>Solana wallet providers and RPC services</li>
            </ul>
            <p>
                These services may collect additional information according to their own
                policies.
            </p>

            <h2>5. Data Security</h2>
            <p>
                We take reasonable technical measures to secure data stored on our
                platform. However, blockchain-based authentication carries inherent
                risks. Users are responsible for safeguarding their own wallets and
                private keys.
            </p>

            <h2>6. Contact</h2>
            <p>
                For questions about this policy, you can contact us at:
                support@muultispace.com
            </p>
        </div>
    );
}
